import { gql } from "@apollo/client";

const GET_APPOINTMENT = gql`
  query GetAppointment($id: ID!) {
    classDetails(id: $id) {
      appointment {
        bookedAt
        status
      }
      myRating {
        id
        teacher {
          rating
          comment
        }
        material {
          rating
          comment
        }
      }
      overlappingAppointments {
        bookedAt
        status
        bookedClass {
          id
          date
          time
        }
      }
    }
  }
`;

export default GET_APPOINTMENT;
